import {
  FusionMelcoModelsColorCollection,
  useAPIAction,
  ColorCollectionsDraftApi,
} from "melco-shared-logic";
import { useFormikContext } from "formik";
import { QueryObserverResult } from "react-query";
import { colorCollectionToInitialValues } from "../../../components/libraries/colorCollections/ColorCollectionDetailForm";

export const useRevertColorCollection = (
  colorCollectionId: string,
  refetch: () => Promise<
    QueryObserverResult<FusionMelcoModelsColorCollection, unknown>
  >
) => {
  const { resetForm } = useFormikContext();

  return useAPIAction(
    ColorCollectionsDraftApi,
    async (api) => {
      const data = await api.userColorCollectionsRevert({
        id: colorCollectionId,
      });

      return {
        successMessages: [
          {
            message: "default",
          },
        ],
        data,
      };
    },
    {
      translationPrefix: "libraries.color_collections.detail.revert",
      onSuccess: async () => {
        const refetchResult = await refetch();

        resetForm({
          values: refetchResult.data
            ? colorCollectionToInitialValues(refetchResult.data)
            : {},
        });
      },
    }
  );
};
